package team.platforma.dictionary_domain.use_case.ai_chapter

import team.platforma.dictionary_data.repository.AiChapterRepository

class NetworkAiChapterUseCase(
    private val repository: AiChapterRepository
) {
    suspend fun load() {
        repository.load()
    }
}